import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import ReduxPromise from 'redux-promise';
import isMobile from 'is-mobile';

import reducers from './reducers';

import MisCertificados from './containers/mis_certificados';
import DetalleUsuario from './containers/detalle_usuario';
import DetalleCompra from './containers/detalle_compra';
import ListadoCursos from './containers/listado_cursos';
import DetalleCurso from './containers/detalle_curso';
import Certificado from './containers/certificado';
import ClassRoom from './containers/classroom';
import Registro from './containers/registro';
import Carrito from './containers/carrito';
import Footer from './components/footer';
import Login from './containers/login';
import Menu from './containers/menu';

export const develop = window.location.hostname==="localhost" || window.location.hostname.includes("192.168.");

if (!develop && window.location.protocol !== 'https:') {
  if (develop) console.log("redireccionado a https");
  else window.location.href = 'https:' + window.location.href.substring(window.location.protocol.length);
}

const createStoreWithMiddleware = applyMiddleware(ReduxPromise)(createStore);
const MisCursos = (props) => {
  return (
    <ListadoCursos deusuario="1" match={props.match}/>
  );
};

const Empty = (props) => {
  return (
      <span/>
  );
};

ReactDOM.render(
  <Provider store={createStoreWithMiddleware(reducers)}>
    <div className={isMobile() ? "mobile" : ""}>
      <BrowserRouter>
        <div>
          <Switch>
            <Route path="/certificado/:idcertificado/:ci" component={Certificado} />
            <Route path="/mis-certificados/" component={MisCertificados} />
            <Route path="/" component={Menu} />
          </Switch>
          <Switch>
            <Route path="/classroom/:idclase" component={ClassRoom} />
            <Route path="/detalle-compra/:idcompra" component={DetalleCompra} />
            <Route path="/curso/:idcurso" component={DetalleCurso} />
            <Route path="/cursos/:pag/:busqueda" component={ListadoCursos} />
            <Route path="/cursos/:pag" component={ListadoCursos} />
            <Route path="/cursos" component={ListadoCursos} />
            <Route path="/alumno" component={DetalleUsuario} />
            <Route path="/estudiante" component={DetalleUsuario} />
            <Route path="/login" component={Login} />
            <Route path="/carrito" component={Carrito} />
            <Route path="/registro" component={Registro} />
            <Route path="/mis-cursos" component={MisCursos} />
            <Route path="/certificado/:idcertificado/:ci" component={Empty} />
            <Route path="/mis-certificados/" component={Empty} />
            <Route path="/" component={ListadoCursos} />
          </Switch>
          <Switch>
            <Route path="/certificado/:idcertificado/:ci" component={Empty} />
            <Route path="/mis-certificados/" component={Empty} />
            <Route path="/" component={Footer} />
          </Switch>
        </div>
      </BrowserRouter>
    </div>
  </Provider>
  , document.querySelector('#APP'));



// WEBPACK FOOTER //
// ./src/index.js